<!--  -->
<template>
  <div class="add_box">
    <div class="search_box">
      <div>
        <!-- <el-input
          v-model="objr.name"
          style="width:200px;margin-right:10px"
          placeholder="请输入名称"
        /> -->
        <el-select
          v-model="objr.account_type"
          placeholder="请选择"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button
          type="primary"
          style="margin-left:10px"
          icon="el-icon-search"
          @click="sraw"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh"
          @click="awered"
        >重置</el-button>
      </div>
      <div>
        <el-button
          type="success"
          icon="el-icon-plus"
          @click="addbit"
        >新增</el-button>
      </div>
    </div>

    <!-- <el-button type="primary" @click="awered">重置</el-button> -->
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%;margin-top:20px"
    >
      <el-table-column
        prop="image_url"
        label="账号名称"
        align="center"
        width="230"
      >
        <template scope="scope">
          <div v-if="scope.row.user_name">{{ scope.row.user_name }}</div>
        </template>
      </el-table-column>

      <!-- <el-table-column
        prop="account_id"
        label="账户ID"
        width="200"
        align="center"
      /> -->
      <el-table-column
        prop="account_type_text"
        label="类型"
        width="200"
        align="center"
      />
      <el-table-column
        prop="busy_state_text"
        label="繁忙状态"
        width="200"
        align="center"
      >
        <template scope="scope">
          <div class="status-wrapper">
            <span :class="['status-dot', getDotClass(scope.row.busy_state)]" />
            <span>{{ scope.row.busy_state_text }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="on_line_text"
        label="在线状态"
        width="200"
        align="center"
      >
        <template scope="scope">
          <div class="status-wrapper">
            <span :class="['status-dot', getDotClass(scope.row.on_line)]" />
            <span>{{ scope.row.on_line_text }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="offline_time_text"
        label="离线时间"
        width="200"
        align="center"
      />

      <el-table-column
        prop="created_at_text"
        label="创建时间"
        align="center"
      />
      <el-table-column
        prop="status"
        label="状态"
        align="center"
      >
        <template scope="scope">
          <div v-if="scope.row.account_type == 3">
            <el-switch
              v-model="scope.row.on_line"
              :active-value="1"
              :inactive-value="2"
              active-text="运行"
              inactive-text="停止"
              :class="scope.row.on_line == 1 ? 'switch-green' : 'switch-gray'"
              @change="(val) => statusChange(val, scope.row)"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="work_status"
        label="操作"
      >
        <!-- slot-scope="scope" -->
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="edit(scope.row)"
          >编辑</el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteItem(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      ref="paginationbox"
      :total="newtotalr"
      :page-sizes="[10]"
      @size-change="fetchPageSizer($event)"
      @current-change="fetchCurrentPager"
    />
    <el-dialog
      :title="adtype === 1 ? '新增' : '编辑'"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      width="25%"
    >
      <readingcreatedialog
        ref="readingcreateview"
        @updatawe="updatawe"
      />
    </el-dialog>
  </div>
</template>

<script>
import readingcreatedialog from './components/readingcreatedialog.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { adxaccountlist, adxaccountdel } from '@/api/report/adx'
// import { initSocket, sendMessage, closeSocket } from '@/utils/socket'
import { authuserupdatemonitorreportiwew } from '@/api/returnPolicyList'
export default {
  components: {
    readingcreatedialog,
    PaginationRight
  },
  data() {
    return {
      dialogVisible: false,
      objr: {
        page: 1,
        pageSize: 10,
        account_type: 0
        // name: null
      },
      adtype: null,
      newtotalr: null,
      tableData: [],
      loading: false,
      options: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: 'ADX'
        },
        {
          value: 2,
          label: '变色龙'
        }
      ]
    }
  },
  created() {
    this.menuList()
  },
  // mounted() {
  //   this.init()
  // },
  beforeDestroy() {
    console.log('销毁')
    // closeSocket()
  },
  methods: {
    // init() {
    //   console.log('mounted', process.env.VUE_APP_BACKUPSOCKET_API_URL)
    //   initSocket(
    //     process.env.VUE_APP_BACKUPSOCKET_API_URL,
    //     data => {
    //       console.log('收到消息:', JSON.parse(data).data.list)
    //       if (JSON.parse(data).data.list) {
    //         console.log('有数据', JSON.parse(data).data)
    //         this.newtotalr = JSON.parse(data).data.total
    //         this.tableData = JSON.parse(data).data.list
    //       } else {
    //         console.log('没数据')
    //       }
    //     },
    //     () => ({
    //       type: 'allClientIdList',
    //       is_adx: 1,
    //       token: localStorage.getItem('Larke-Admin-Token'),
    //       additional: { page: this.objr.page, pageSize: this.objr.pageSize, account_type: this.objr.account_type }
    //     })
    //   )
    // },
    // send() {
    //   sendMessage('Hello from Vue 2 with heartbeat!')
    // },
    async menuList() {
      // 获取列表
      this.loading = true
      const data = await adxaccountlist(this.objr)
      console.log('data', data)
      this.loading = false
      this.tableData = data.data.list
      this.newtotalr = data.data.total
    },
    sraw() {
      this.objr.page = 1
      // this.objr.pageSize = 10
      this.menuList()
    },
    awered() {
      this.objr.page = 1
      this.objr.account_type = 0
      // this.objr.name = ''
      this.menuList()
    },
    addbit() {
      this.dialogVisible = true
      this.adtype = 1
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.readingcreateview.send(1)
      }, 100)
    },
    edit(item) {
      this.dialogVisible = true
      this.adtype = 2
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.readingcreateview.send(2, item)
      }, 100)
    },
    // 删除
    async deleteItem(row) {
      this.$confirm('是否确定删除该条信息吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        await adxaccountdel({ user_name: row.user_name, account_type: row.account_type })
        this.menuList()
        this.$message({
          message: '删除成功',
          type: 'success'
        })
      })
    },
    // 分页
    fetchPageSizer(e) {
      this.objr.pageSize = e
      this.menuList()
    },
    fetchCurrentPager(e) {
      this.objr.page = e
      this.menuList()
    },
    updatawe() {
      this.dialogVisible = false
      this.menuList()
    },
    getDotClass(status) {
      switch (status) {
        case 1:
          return 'dot-green' // 绿色
        case 2:
          return 'dot-gray' // 灰色
        default:
          return 'dot-red' // 未知状态
      }
    },
    statusChange(val, row) {
      console.log('val', val)
      authuserupdatemonitorreportiwew({ id: row.id })
        .then(res => {
          this.$message({
            message: '设置成功',
            type: 'success'
          })
          this.menuList()
        })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.add_box {
  padding: 20px;
}
.search_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.status-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #666;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 6px;
}

.dot-green {
  background-color: #52c41a;
}
.dot-red {
  background-color: #ff4d4f;
}
.dot-gray {
  background-color: #d9d9d9;
}
/* 如果是在 <style scoped> 中，加上 >>> 或 /deep/ 选择内部类 */
.switch-green >>> .el-switch__core,
.switch-green /deep/ .el-switch__core {
  background-color: #13ce66 !important;
  border-color: #13ce66 !important;
}

.switch-gray >>> .el-switch__core,
.switch-gray /deep/ .el-switch__core {
  background-color: #bfbfbf !important;
  border-color: #bfbfbf !important;
}
</style>
